/** 设备管理员相关接口 */
import request from '@/utils/util.request';

/*
 *  (admins) 加载管理员数据
 */
export const admins_load_data = (data) => {
	return request({
		url: '/admins/loaddata',
		data,
	});
};

/*
 *  (admins) 解绑自身
 */
export const admins_unbind = (data) => {
	return request({
		url: '/admins/unbind',
		data,
	});
};

/*
 *  (admins) 添加管理员
 *  @param {string} phone: 手机号
 */
export const admins_add = (data) => {
	return request({
		url: '/admins/add',
		data,
	});
};

/*
 *  (admins) 移除管理员
 *  @param {string} phone: 手机号
 */
export const admins_remove = (data) => {
	return request({
		url: '/admins/remove',
		data,
	});
};

/*
 *  (admins) 迁移超级管理员
 *  @param {string} phone: 手机号
 */
export const admins_change = (data) => {
	return request({
		url: '/admins/change',
		data,
	});
};
